const strictEqual = (a: unknown, b: unknown) => a === b;
const nonStrictEqual = (a: unknown, b: unknown) => a == b;

type SearchQueriesMatch = {
  searchQueries: { [key: string]: any }[];
  paramsToCompare: string[];
  options?: {
    isStrictEquals?: boolean;
  };
};

// We use nonStrictEquals because passengers etc. is sometimes stored as a number in state,
// where as from the global searchQuery, it'll always be a string.
const searchQueriesMatch = ({
  searchQueries,
  paramsToCompare,
  options,
}: SearchQueriesMatch) => {
  const { isStrictEquals = false } = options || {};

  if (searchQueries.filter(Boolean)?.length < 2) {
    return true;
  }

  const isEqual = isStrictEquals ? strictEqual : nonStrictEqual;

  for (const param of paramsToCompare) {
    let originalParamVal;

    for (let i = 0; i < searchQueries.length; i++) {
      const searchQuery = searchQueries[i];
      const otherParamVal = searchQuery?.[param];
      // Store values from first searchQuery
      if (i === 0) {
        originalParamVal = otherParamVal;
      } else if (!isEqual(originalParamVal, otherParamVal)) {
        return false;
      }
    }
  }
  return true;
};

export default searchQueriesMatch;
